<div class="flex justify-center">
    <a
        secondary
        [href]="externalLinks.contactUs"
        target="_blank"
        rel="noopener noreferrer"
    >
        Contact Us
    </a>
</div>
